export enum RolesEnum {
    ADMIN = 'Admin',
    STAFF = 'Staff',
    USER = 'User',
    PARENT = 'Parent',
    RELATIVE = 'Relative',
    MANAGER = 'Manager',
    APPROVAL = 'Approval',
    OWNER = 'Owner',
    SECRETARY = 'Secretary',
    TEST = 'Test',
  }
  